<div class="sticky-note" [style.background-color]="bgColor">
  <h3 class="title">{{ title }} <i *ngIf="iconClass" class="{{ iconClass }}"></i></h3>
  <ul class="note-list">
    <li *ngFor="let note of noteList">{{ note }}</li>
  </ul>
</div>